<script setup lang="ts">
import { toRef } from 'vue';
import type { CompanyPulseData } from '@/types/DataTypes';
import PulseTimeAllocationDisplay from './PulseTimeAllocationDisplay.vue';
import { usePulseStats } from '@/composables/usePulseStats';

interface Props {
  teamPulses: CompanyPulseData[];
}

const props = defineProps<Props>();

// Convert props to reactive reference for the composable
const teamPulsesRef = toRef(props, 'teamPulses');

// Use the centralized stats calculation logic
const { stats } = usePulseStats(teamPulsesRef);
</script>

<template>
  <div class="flex items-center gap-2" @click.stop>
    <div v-if="Object.keys(stats.companyAllocation).length > 0" class="grow">
      <PulseTimeAllocationDisplay :time-allocation="stats.companyAllocation" :show-unallocated="true" :show-legend="false" />
    </div>
    <div v-else class="text-xs text-gray-400">No data</div>
  </div>
</template>

